import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { UserPlus, UserMinus } from 'lucide-react';
import { cn } from '@/lib/utils';

const memberChangeBadgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        // add: "bg-green-50 border-green-200 text-green-800",
        // remove: "bg-red-50 border-red-200 text-red-800",
        add: 'bg-zinc-50 border-zinc-200 text-zinc-800',
        remove: 'bg-zinc-50 border-zinc-200 text-zinc-800',
      },
    },
    defaultVariants: {
      variant: 'add',
    },
  }
);

interface MemberChangeBadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof memberChangeBadgeVariants> {
  changeType: 'add' | 'remove';
  text: string;
}

const getIcon = (changeType: 'add' | 'remove') => {
  switch (changeType) {
    case 'add':
      return <UserPlus className="h-3 w-3" />;
    case 'remove':
      return <UserMinus className="h-3 w-3" />;
    default:
      return null;
  }
};

export function MemberChangeBadge({
  className,
  changeType,
  text,
  ...props
}: MemberChangeBadgeProps) {
  return (
    <div
      className={cn(
        memberChangeBadgeVariants({ variant: changeType }),
        className
      )}
      {...props}
    >
      {getIcon(changeType)}
      <span>{text}</span>
    </div>
  );
}
